"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _formatCommodityData = require("../../utils/formatCommodityData");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  FlexNavigate = _require.FlexNavigate;
const formatFlexNavigate = properties => {
  const _properties$anchor = properties.anchor,
    anchor = _properties$anchor === void 0 ? [] : _properties$anchor,
    _properties$btnLink = properties.btnLink,
    btnLink = _properties$btnLink === void 0 ? {} : _properties$btnLink;
  const resultList = anchor.map((item, index) => {
    const _item$label = item.label,
      label = _item$label === void 0 ? '' : _item$label,
      _item$anchorId = item.anchorId,
      anchorId = _item$anchorId === void 0 ? '' : _item$anchorId;
    return {
      label,
      anchorId,
      extendProps: {
        'report-event': 'click_navigator_tab',
        'report-ext1': index + 1,
        'report-ext2': label,
        'report-ext3': anchorId
      }
    };
  });
  return {
    anchor: resultList,
    btnLink
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit // {(event: string) => void | Promise<void>} 监听事件
}) {
  if (Object.keys(data).length >= 1) {
    const _formatFlexNavigate = formatFlexNavigate(data),
      anchor = _formatFlexNavigate.anchor,
      btnLink = _formatFlexNavigate.btnLink;
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(btnLink.commodityObject);
    const onNavigatorTabClick = function (item, index) {
      const label = item && item.label;
      window.recordBehavior && window.recordBehavior.reportEvent('click_navigator_tab', {
        ext1: index + 1,
        ext2: label
      });
    };
    return anchor.length !== 0 ? /*#__PURE__*/React.createElement(FlexNavigate, {
      configuration: anchor,
      onTabClick: onNavigatorTabClick,
      isExternal: true,
      btnLink: btnLink,
      onCallBack: () => {
        window.asyncReceiveCommodity(_objectSpread(_objectSpread({}, resultCommodityObject), {}, {
          href: btnLink === null || btnLink === void 0 ? void 0 : btnLink.link
        }));
      }
    }) : /*#__PURE__*/React.createElement("div", null);
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}